<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader class="items-center">
                <template #icon>
                    <PipedriveLogo />
                </template>
                <DialogTitle>{{
                    $t("integrations.pipedrive.modal.title")
                }}</DialogTitle>
            </DialogHeader>

            <div class="px-6 py-4"></div>

            <DialogFooter
                class="w-full"
                :class="cn(removable ? '!justify-between' : 'justify-end')"
            >
                <Button
                    v-if="removable"
                    @click="$emit('remove-integration')"
                    variant="destructive-ghost"
                    class="gap-1 flex"
                    size="xs"
                >
                    <Trash :size="16" />
                    {{ $t("integrations.remove_integration") }}
                </Button>

                <div class="flex-end flex">
                    <DialogClose>
                        <Button class="ml-4" variant="outline" type="button">{{
                            $t("cancel")
                        }}</Button>
                    </DialogClose>
                </div>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { cn } from "@/lib/utils";
import { ref } from "vue";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "@/components/ui/dialog-v2";
import PipedriveLogo from "../logos/Pipedrive.svg";
import { Trash } from "lucide-vue-next";
import { Button } from "@/components/ui/button";

defineProps<{
    integration?: any;
    removable?: boolean;
}>();
const opened = ref(false);

const closeModal = () => {
    opened.value = false;
};
</script>

<style></style>
